module.exports = __webpack_public_path__ + "img/jacket.6231fc0a.jpg";